export const postDownloadToNative = (proposalNo, fileName, downloadUrl, authToken) => {
    if (!window.ReactNativeWebView) {
        return false;
    }

    window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'DOWNLOAD',
        proposalNo,
        fileName,
        downloadUrl,
        authToken,
    }));

    return true;
};
